<template>
  <div class="page home">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">Privacy Policy</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="'id' in pageData">
      <h1>Privacy Policy for the Austin Studio Tour App</h1>
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-container">
        <div class="groups">
          <div v-for="group in pageData.acf.groups" :class="`group size-${group.size}`" :key="group.name">
            <h2>{{group.name}}</h2>
            <div v-html="group.list" :class="`wysiwyg columns-${group.columns}`"></div>
          </div>
        </div>
      </div>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'ThankYou',
  components: { Components, HeaderNav, Footer },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/30021?v=6`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

h1 {
  margin: 50px 0 0 0;
  text-align: center;
}

.groups {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .group {
    width: 33%;
    margin-bottom: 80px;
    text-align: center;
    &.size-full {
      width: 100%;
    }
    @media (max-width: @mobile) {
      width: 100%;
    }
    h2 {
      margin-bottom: 10px;
    }
    .wysiwyg {
      &.columns-3 {
        column-count: 3;
        @media (max-width: @mobile) {
          column-count: 2;
        }
      }
      &.columns-4 {
        column-count: 4;
        @media (max-width: @mobile) {
          column-count: 3;
        }
      }
    }
  }
}
</style>

<style lang="less">
@import '../css/variables';

.groups {
  .wysiwyg {
    &.columns-4 {
      p {
        font-size: 14px;
      }
    }
    p {
      margin-bottom: 0;
      line-height: 30px;
      @media (max-width: @mobile) {
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue